export function serializeUnknownForLog(value: unknown, depth = 0): unknown {
	if (depth > 6) {
		return "[max-depth]";
	}
	if (value == null || typeof value !== "object") {
		return value;
	}
	if (value instanceof Error) {
		const record = value as Error & {
			code?: unknown;
			data?: unknown;
			cause?: unknown;
			issues?: unknown;
		};
		return {
			name: record.name,
			message: record.message,
			code: record.code,
			data: serializeUnknownForLog(record.data, depth + 1),
			cause: serializeUnknownForLog(record.cause, depth + 1),
			issues: serializeUnknownForLog(record.issues, depth + 1),
		};
	}
	if (Array.isArray(value)) {
		return value.map((entry) => serializeUnknownForLog(entry, depth + 1));
	}
	const record = value as Record<string, unknown>;
	const output: Record<string, unknown> = {};
	for (const [key, entry] of Object.entries(record)) {
		output[key] = serializeUnknownForLog(entry, depth + 1);
	}
	return output;
}
